var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;return _c('div', { staticClass: "audio-item" }, [_c('div', { staticClass: "name", domProps: { "innerHTML": _vm._s(_vm.name) } }), _vm._v(" "), _c('div', { staticClass: "action" }, [_c('audio-play', { ref: "audioPlayer", attrs: { "resource": _vm.resource }, on: { "play": function play(cb) {
        return _vm.$emit('play', cb);
      } } }), _vm._v(" "), _c('add-resource-to-used', { attrs: { "resource": _vm.resource }, on: { "addResource": function addResource(res) {
        return _vm.$emit('addResource', res);
      } } })], 1)]);
};
var staticRenderFns = [];

export { render, staticRenderFns };